import { CallApi } from "../callApi";
import { APIS } from "../../../_config";

export interface newWineFormData {
  producer_id: string;
  literal: string;
  label_name: string;
  variety: number;
  color: string;
  sweetness: string;
  type: string;
  country: number;
  region: number;
  sub_region: number;
  appellation: number;
  sub_appellation: number;
  all_appellations_tree: string;
  noise: string[];
  producer_keyword: string;
  base_keyword: string;
  appellation_keyword: string;
  color_keyword: string;
  common_modifiers: string;
  modifiers: string;
  custom_nots: string;
  global_nots: string;
  keyword: string;
}

export function useDirectInputApi() {

    //get wines
    const getWines = async (params: any = {}): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.WINES.WINES, {...params}, true);
    };
    
    //get wine by ID
    const getWineById = async (id: string): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.WINES.WINE_BY_ID(id), {}, true);
    };

    //get wine by literal
    const getWineByLiteral = async (literal: string): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.WINES.WINE_BY_LITERAL(literal), {}, true);
    };

    //create wines
    const createWine = async (data : newWineFormData): Promise<any> => {
        return CallApi.POST(APIS.WINE_ADDITION.DIRECT_INPUT.WINES.WINES, data, true);
    };

    //update wine
    const updateWine = async (id: string, data: newWineFormData): Promise<any> => {
        return CallApi.PUT(APIS.WINE_ADDITION.DIRECT_INPUT.WINES.WINE_BY_ID(id), data, true);
    };

    //get Producers
    const getProducer = async (params: any = {}): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.PRODUCERS.PRODUCERS, { ...params }, true);
    };
    
    //get producer by ID
    const getProducerById = async (id: string): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.PRODUCERS.PRODUCER_BY_ID(id), {}, true);
    };
    
    //create producer
    const createProducer = async (data: any): Promise<any> => {
        return CallApi.POST(APIS.WINE_ADDITION.DIRECT_INPUT.PRODUCERS.PRODUCERS, data, true);
    };
    
    //update producer
    const updateProducer = async (id: string, data: any): Promise<any> => {
        return CallApi.PUT(APIS.WINE_ADDITION.DIRECT_INPUT.PRODUCERS.PRODUCER_BY_ID(id), data, true);
    };

    //get variety list
    const getVarietyList = async (params: any = {}): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.WINES.VARIETY, { ...params },true);
    };

    //get color list
    const getColorList = async (params: any = {}): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.WINES.COLOR, { ...params },true);
    };

    //get sweetness list
    const getSweetnessList = async (params: any = {}): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.WINES.SWEETNESS, { ...params },true);
    };

    //get type list
    const getTypeList = async (params: any = {}): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.WINES.TYPE, { ...params },true);
    };

    //get literal
    const getLiteral = async (params: any = {}): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.WINES.LITERAL_BY_REG_CODE, { ...params }, true);
    };

    //get literal for producer
    const getLiteralforProducer = async (params: any = {}): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.PRODUCERS.LITERAL_BY_REG_CODE, { reg_code: params.reg_code }, true);
    };

    //get sub-appellations
    const getSubAppellations = async (params: any = {}): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.WINES.SUB_APPELLATION, { params },true);
    };

    //get noise
    const getNoise = async (params: any = {}): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.WINES.NOISE, { params },true);
    };

    //get keywords
    const getWordAliases = async (params: any = {}): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.GENERATE_KEYWORDS.WORD_ALIASES, { ...params },true);
    };

    const getWordEliminations = async (params: any = {}): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.GENERATE_KEYWORDS.WORD_ELIMINATIONS, { ...params },true);
    };

    const getWordChanges = async (params: any = {}): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.GENERATE_KEYWORDS.WORD_CHANGES, { ...params }, true);
    };

    const getSpreadTables = async (params: any = {}): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.GENERATE_KEYWORDS.SPREAD_TABLES, { ...params },true);
    };

    const getKeywordSubstitutions = async (params: any = {}): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.GENERATE_KEYWORDS.KEYWORD_SUBSTITUTIONS, { ...params }, true);
    };

    const getReservedWords = async (params: any = {}): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.GENERATE_KEYWORDS.RESERVED_WORDS, { ...params }, true);
    };

    const getVintages = async (params: any = {}): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.DIRECT_INPUT.GENERATE_KEYWORDS.VINTAGES, { params }, true);
    };

    const mergeWines = async (data: any): Promise<any> => {
        return CallApi.POST(APIS.WINE_ADDITION.DIRECT_INPUT.WINES.MERGE, data, true);
    };

    return {
        getVarietyList,
        getColorList,
        getSweetnessList,
        getTypeList,
        getSubAppellations,
        getNoise,
        getLiteral,
        getLiteralforProducer,
        getWines,
        getProducer,
        getProducerById,
        updateProducer,
        getWineById,
        getWineByLiteral,
        createProducer,
        createWine,
        updateWine,
        getWordAliases,
        getWordEliminations,
        getWordChanges,
        getSpreadTables,
        getKeywordSubstitutions,
        getReservedWords,
        getVintages,
        mergeWines
    };
}